/* global App */
import { React } from 'vendor-react';
import AbstractControlledInput from '../AbstractInput/index';
import { createKey } from '../../../../../common/react-helpers/key-creator';

const hasNoValue = App.Utils.Object.hasNoValue;
const hasValue = App.Utils.Object.hasValue;

const DEFAULT_PLACEHOLDER_LABEL = 'Please select one';
const FORM_APP_PAGE = 'form-application-page';

class SelectInput extends AbstractControlledInput {
    constructor(props) {
        super(props);
        this.closeSelect = this.closeSelect.bind(this);
        this.selectClickHandler = this.selectClickHandler.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);

        this.documentClickHandlerRemover = null;
        this.listRef = null;
        this.selectRef = null;
        this.placeholder = this.props.placeholder || DEFAULT_PLACEHOLDER_LABEL;
        this.state = {
            open: false,
        };
    }

    closeSelect() {
        this.setState({
            open: false,
        });
        this.removeDocumentHandler();
    }

        onBlur(event) {
        this.props.onBlur && this.props.onBlur(event);
    }

    removeDocumentHandler() {
        this.documentClickHandlerRemover && this.documentClickHandlerRemover();
        this.documentClickHandlerRemover = null;
    }

    selectClickHandler(event) {
        event.stopPropagation();
        if (this.state.open) {
            this.closeSelect();
            return;
        }

        document.addEventListener('click', this.closeSelect);
        this.documentClickHandlerRemover = () =>
            document.removeEventListener('click', this.closeSelect);

        this.setState(
            {
                open: true,
            },
            () => {
                this.scrollToLabel();
            }
        );
    }

    scrollToLabel() {
        //Work around, improvement accepted.
        if (window.innerHeight - this.listRef.getBoundingClientRect().bottom < 0) {
            this.selectRef.parentElement.parentElement.scrollIntoView();
            const isFormApp = document.body.classList.contains(FORM_APP_PAGE);
            if (!isFormApp) {
                window.scrollBy(0, -App.Utils.Helpers.getNavigationHeight());
            }
        }
    }

    isOptionSelected(option) {
        const value = this.getValue();
        return (
            (hasNoValue(value) && hasNoValue(option)) ||
            (hasValue(option) && value === option.value)
        );
    }

    getOptionClassName(option) {
        return this.isOptionSelected(option) ? 'selected' : '';
    }

    selectItem(idx, event) {
        event.stopPropagation();
        this.closeSelect();
        this.onChange({ target: { selectedIndex: idx } });
    }

    onChange(event) {
        const idx = event.target.selectedIndex;
        this.props.onChange(idx > 0 ? this.props.options[idx - 1].value : null);
    }

    getSelectedOption() {
        const value = this.getValue();
        return (
            this.props.options.find(option => option.value === value) || {
                label: this.placeholder,
                value: null,
            }
        );
    }

    renderInput() {
        const { name, options, required } = this.props;
        const { open } = this.state;

        const selectedOption = this.getSelectedOption();

        return (
            <div
                ref={ref => (this.selectRef = ref)}
                onBlur={this.onBlur}
                tabIndex="0"
                className={`select-input ${open ? 'open' : ''}`}
            >
                <select
                    className="select-input__select-input"
                    name={name}
                    onChange={this.onChange}
                    placeholder={this.placeholder}
                    value={this.getValue()}
                    required={required}
                >
                    <option value="">{this.placeholder}</option>
                    {options.map((option, idx) => (
                        <option key={createKey(idx, option.value)} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>

                <div
                    className={`form-control select-input__fake-input ${
                        selectedOption.value === null ? 'placeholder' : ''
                    }`}
                    onClick={this.selectClickHandler}
                >
                    <div className="select-input__fake-input-label-wrapper">
                        <div className="select-input__fake-input-label">{selectedOption.label}</div>
                    </div>
                </div>

                <div ref={ref => (this.listRef = ref)} className="select-input__dropdown">
                    <ul>
                        {options.map((option, idx) => (
                            <li
                                key={createKey(idx, option.value)}
                                onClick={this.selectItem.bind(this, idx + 1)}
                                className={this.getOptionClassName(option)}
                            >
                                {option.label}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./collection-institutional-portal/src/modules/react-forms/scripts/Components/SelectInput/index.js